import React from 'react';
import { css } from '@emotion/core';
import Services from './Services/Services';

const ServicesFooter = ({
  services,
  primaryColor,
  secondaryColor,
  datiFarmacia,
  footerVersion
}) => {
  return (
    <div className="container-fluid">
      <Services
        services={services}
        primaryColor={primaryColor}
        datiFarmacia={datiFarmacia}
        secondaryColor={secondaryColor}
        footerVersion={footerVersion}
      />
    </div>
  );
};
export default ServicesFooter;
